// @ts-nocheck
const mapDcneAvailability = (availabilityStatus: string | { [key: string]: string }) => {
    const availability = typeof availabilityStatus === "string" ? JSON.parse(availabilityStatus) : availabilityStatus;
    const mappedDcneAvailability: { stock_id?: string; stock_status?: string } = {};
    if (availability && availability.Status) {
        mappedDcneAvailability.stock_id = availability.Status;
    }
    if (availability && availability.StatusName) {
        mappedDcneAvailability.stock_status = availability.StatusName;
    }
    return mappedDcneAvailability;
};

export default mapDcneAvailability;
